<template>
    <div>

        <v-snackbar
                v-for="(notice, index) in notices"
                :key="index"
                :value="notice.showing"
                @input="hide(index)"
                :color="notice.color"
                :style="`bottom: ${(index * 60) + 8}px`"
        >
            {{notice.text}}

            <template v-slot:action="{ attrs }">
                <v-btn
                        text
                        v-bind="attrs"
                        @click="hide(index)"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>


    </div>
</template>

<script>

    import {mapActions, mapGetters} from "vuex";

    export default {
        computed: {
            ...mapGetters('notification', [
                'notices',
            ]),
        },
        methods: {
            ...mapActions('notification', [
                'hide',
            ]),
        },
    }
</script>

<style scoped>

</style>